
import $ from "jquery";

export function displayActivitiesHeader(response, container = '.activiteiten'){
    let results = $(container).find(container + '__results');
    if (response.data.length > 0){
        results.prepend(
            `<div class="d-f t-13 t-c-s w-400 activiteiten__head hidden-small">
                    <div class="flex-15 d-f f-a-c gap-8"></div>
                    <div class="flex-15 d-f f-a-c gap-8">
                        <img width="15" height="15" src="/wp-content/uploads/2024/10/Icon-fill-4.svg" alt="">Datum
                    </div>
                    <div class="flex-20 d-f f-a-c gap-8">
                        <img width="15" height="15" src="/wp-content/uploads/2024/10/Icon-fill-1.svg" alt="">Activiteit
                    </div>
                    <div class="flex-20 d-f f-a-c gap-8">
                        <img width="15" height="15" src="/wp-content/uploads/2024/10/Icon-fill.svg" alt="">Locatie
                    </div>
                    <div class="flex-15 d-f f-a-c gap-8">
                        <img width="15" height="15" src="/wp-content/uploads/2024/10/Icon-fill-5.svg" alt="">Soort
                    </div>
                    <div class="flex-10 d-f f-a-c gap-8"></div>
                </div>`
        );
    }
    else{
        results.append('<h4 class="t-center">Geen geplande activiteiten gevonden</h4>');
    }
    
}

export function addActivities(response, container = '.activiteiten') {
    
    // Remove duplicate activities based on ID
    const uniqueActivitiesMap = new Map();
    response.data.forEach(activity => {
        if (!uniqueActivitiesMap.has(activity.id)) {
            uniqueActivitiesMap.set(activity.id, activity);
        }
    });

    const uniqueActivities = Array.from(uniqueActivitiesMap.values());

    // Replace the original data with the unique one
    response.data = uniqueActivities;

    let activities = response.data;
    let resultsWrap = $(container).find('.activiteiten__results-wrap');
    let results = $(container).find('.activiteiten__results');
    resultsWrap.removeClass("loading");

    activities.forEach(activity => {
        let activiteitHTML = generateActivity(activity);
        results.append(activiteitHTML);
    });

    if (response.meta.current_page < response.meta.last_page){
        results.append(`
            <div class="t-center meer-activiteiten" data-page="${response.meta.current_page + 1}">
                <span class="btn btn--transparent btn--arrow">Bekijk meer activiteiten</span>
            </div>
            `);
    }
}   


function generateActivity(activity){
    let slug = activity.title
    .toLowerCase()
    .replace(/\s+/g, '-')       // Replace spaces with dashes
    .replace(/[\/\\#?&%]+/g, '-') // Replace URL-unfriendly characters with dashes
    .replace(/[^a-z0-9\-]/g, '') // Remove any remaining unsafe characters (optional)
    .replace(/-+/g, '-')         // Collapse multiple dashes
    .replace(/^-|-$/g, '');      // Trim leading/trailing dashes

    return `
        <a href="/activiteiten/${slug}?id=${activity.id}" class="d-f activiteit-item card lightgreen gap-16-s" data-id="${activity.id}" data-date="${activity.start_date}" data-title="${activity.title}">
            <div class="activiteit-item__image flex-15 flex-50-s d-f f-a-c gap-8">
                <div class="activiteit-item__inner l-0">
                    <img width="100" height="100" src="${activity.team.avatar.small}"></img>
                </div>
            </div>
            <div class="flex-15 flex-grow d-f fd-c f-j-c">
                <div class="activiteit-item__inner">
                    ${getFormattedDate(activity.start_date)}
                </div>
            </div>
            <div class="flex-20 flex-100-s d-f f-a-c gap-8">
                <div class="activiteit-item__inner d-f fd-c-s gap-8">
                    <span class="t-c-s w-400 d-f gap-8 hidden-small-reverse">
                        <img width="22" height="22" src="/wp-content/uploads/2024/10/Icon-fill-1.svg" alt="">
                        <strong>Activiteit</strong>
                    </span>
                    ${activity.title}
                </div>
            </div>
            <div class="flex-20 flex-100-s d-f fd-c f-j-c">
                <div class="activiteit-item__inner d-f fd-c-s gap-8">
                    <span class="t-c-s w-400 d-f gap-8 hidden-small-reverse">
                        <img width="22" height="22" src="/wp-content/uploads/2024/10/Icon-fill.svg" alt="">
                        <strong>Locatie</strong>
                    </span>
                    ${activity.location_name}
                </div>
            </div>
            <div class="flex-15 flex-100-s d-f f-a-c gap-8">
                <div class="activiteit-item__inner d-f fd-c-s gap-8">
                    <span class="t-c-s w-400 d-f gap-8 hidden-small-reverse">
                        <img width="22" height="22" src="/wp-content/uploads/2024/10/Icon-fill-5.svg" alt="">
                        <strong>Soort</strong>
                    </span>
                    <span class="bubble bubble--green t-13 br-8">Openbaar</span>
                </div>
            </div>
            <div class="flex-15 flex-100-s d-f f-a-c gap-8 f-j-e">
                <div class="activiteit-item__inner d-f gap-8">
                    <span class="btn btn--transparent open-popup activiteit-item__popup" data-popup="popup-aanmelding-activiteit">Aanmelden</span>
                </div>
            </div>
        </a>
    `;
}

$(document).on("click", ".activiteit-item__popup", function(e) {
    let activiteitId = $(this).closest('.activiteit-item').data('id');
    let activiteitTitle = $(this).closest('.activiteit-item').data('title');
    let activiteitDate = $(this).closest('.activiteit-item').data('date');
    $('#popup-aanmelding-activiteit form').find('input[name="activiteit-id"').val(activiteitId);
    var parts = activiteitDate.split('T')[0].split('-');
    var formattedDate = parts[2] + '-' + parts[1] + '-' + parts[0];

    $('#popup-aanmelding-activiteit form').find('input[name="activiteit-datum"]').val(formattedDate);

    $('#popup-aanmelding-activiteit form').find('input[name="activiteit-naam"').val(activiteitTitle);
});


export function getFormattedDate(dateString, horizontal = false) {
    if (!dateString) return '';

    let dateObj = new Date(dateString);

    // Days and months in Dutch
    let dagen = ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'];
    let maanden = [
        '', 'Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 
        'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'
    ];

    let dag = dagen[dateObj.getDay()];
    let maand = maanden[dateObj.getMonth() + 1]; // JavaScript months are 0-indexed

    let containerClass = horizontal ? 'd-f f-a-c gap-8' : 'd-f fd-c';

    return `
        <div class="${containerClass}">
            <p class="w-600 t-40">${dateObj.getDate()}</p>
            <div class="d-f fd-c">
                <p>${maand}</p>
                <p class="t-c-s t-13">${dag}</p>
            </div>
        </div>
    `;
}
// Initialize a map for either a full route or a single coordinate
export function initializeRouteMap(element, exercisePoints = [], waypoints = []) {
    // If both exercisePoints and waypoints are empty, do not load the map
    if (exercisePoints.length === 0 && waypoints.length === 0) {
        return;
    }

    // Determine the center of the map
    const centerPoint = exercisePoints.length > 0 
        ? { lat: exercisePoints[0].lat, lng: exercisePoints[0].lng } 
        : { lat: waypoints[0].lat, lng: waypoints[0].lng };


    // Default zoom level (used if only one waypoint exists)
    let zoomLevel = 14;

    // Create a bounds object to dynamically adjust the zoom if needed
    const bounds = new google.maps.LatLngBounds();

    // Add exercise points and waypoints to bounds
    exercisePoints.forEach(point => bounds.extend(new google.maps.LatLng(point.lat, point.lng)));
    waypoints.forEach(point => bounds.extend(new google.maps.LatLng(point.lat, point.lng)));

    // Map options
    const mapOptions = {
        center: centerPoint,
        zoom: zoomLevel, // Default zoom, will be overridden if multiple waypoints exist
        disableDefaultUI: false,
        zoomControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        gestureHandling: 'cooperative',
        styles: [
            {
                "featureType": "road.highway",
                "stylers": [
                    { "hue": "#FFC200" },
                    { "saturation": -61.8 },
                    { "lightness": 45.6 },
                    { "gamma": 1 }
                ]
            },
            {
                "featureType": "water",
                "stylers": [
                    { "hue": "#0078FF" },
                    { "saturation": -13.2 },
                    { "lightness": 2.4 },
                    { "gamma": 1 }
                ]
            }
        ]
    };

    // Initialize the map
    const map = new google.maps.Map(element, mapOptions);
    const customIcon = 'https://stg-qrfit-qrfit.kinsta.cloud/wp-content/uploads/2025/01/gren.svg';


    map.setCenter(centerPoint);

    // Add markers for exercise points
    exercisePoints.forEach((point) => {
        new google.maps.Marker({
            position: point,
            map: map,
            icon: customIcon,
        });
    });

    // Draw the route if waypoints exist
    if (waypoints.length > 0) {
        const polylinePath = waypoints.map(point => new google.maps.LatLng(point.lat, point.lng));

        const routePolyline = new google.maps.Polyline({
            path: polylinePath,
            geodesic: true,
            strokeColor: '#000000',
            strokeOpacity: 1.0,
            strokeWeight: 4,
        });

        routePolyline.setMap(map);
    }

    // Adjust zoom only if there are multiple waypoints
    if (waypoints.length > 1) {
        map.fitBounds(bounds);
    }

    return map;
}
